import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { forwardRef } from "react";
import { Input } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SearchInputComponent = function SearchInputComponent(props, ref) {
  return ___EmotionJSX(Input, _extends({
    px: {
      sm: "10px",
      md: "20px"
    },
    height: 47,
    fontWeight: "light",
    borderRadius: props.isOpen ? "4px 0 0 0" : "4px 0 0 4px",
    borderColor: "#ddd!important",
    "data-cnstrc-search-input": true,
    ref: ref
  }, props));
};
export var SearchInput = /*#__PURE__*/forwardRef(SearchInputComponent);